require('../../modules/es6.number.is-integer');
module.exports = require('../../modules/_core').Number.isInteger;



/*****************
 ** WEBPACK FOOTER
 ** ./~/@babel/runtime-corejs2/~/core-js/library/fn/number/is-integer.js
 ** module id = 426
 ** module chunks = 0
 **/